import { render, staticRenderFns } from "./DeviceInfoList.vue?vue&type=template&id=8580848a&scoped=true&"
import script from "./DeviceInfoList.vue?vue&type=script&lang=js&"
export * from "./DeviceInfoList.vue?vue&type=script&lang=js&"
import style0 from "./DeviceInfoList.vue?vue&type=style&index=0&id=8580848a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8580848a",
  null
  
)

export default component.exports